import React, { useEffect, useRef, useState } from "react";
import { realTimeDB } from "../../firebase";
import styled, { keyframes } from "styled-components";
import { onValue, ref } from "firebase/database";

const ResultDeclaration = ({ onResultDeclare }) => {
  const [mainNumber, setMainNumber] = useState(undefined);
  const [secondaryNumber, setSecondaryNumber] = useState(undefined);
  const [isLive, setIsLive] = useState(false);
  const mainRef = useRef();
  const secondaryRef = useRef();
  const realTimeDbRef = ref(realTimeDB, "status");
  useEffect(() => {
    const unSubscribe = onValue(realTimeDbRef, (snapshot) => {
      const value = snapshot.val();

      setIsLive(value.live);
      debugger;
      setTimeout(() => {
        setMainNumber(value.mainNumber);
      }, 1000);
      setTimeout(() => {
        setSecondaryNumber(value.secondaryNumber);
      }, 2000);
    });
    return () => unSubscribe();
  }, [realTimeDbRef]);

  useEffect(() => {
    if (!isLive && !mainNumber) {
      onResultDeclare();
    }
    // eslint-disable-next-line
  }, [isLive, mainNumber]);

  useEffect(() => {
    if (mainNumber > 0) {
      mainRef.current?.classList.toggle("flipped");
    }
  }, [mainNumber]);

  useEffect(() => {
    if (secondaryNumber > 0) {
      secondaryRef.current?.classList.toggle("flipped");
    }
  }, [secondaryNumber]);
  return (
    <>
      {isLive && (
        <>
          <MainWrapper>
            <div className="ball"></div>
            <div>Live</div>
          </MainWrapper>
          <Wrapper>
            <div class="card-container">
              <div class="card" ref={mainRef}>
                <div class="card-front"></div>
                <div class="card-back">
                  <h2>{mainNumber}</h2>
                </div>
              </div>
            </div>
            <div class="card-container secondary">
              <div class="card" ref={secondaryRef}>
                <div class="card-front"></div>
                <div class="card-back">
                  <h2>{secondaryNumber}</h2>
                </div>
              </div>
            </div>
          </Wrapper>
        </>
      )}
    </>
  );
};

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
const MainWrapper = styled.div`
  display: flex;
  gap: 12px;
  font-weight: 600;
  font-size: 18px;
  justify-content: center;
  align-items: center;
  margin: 12px 0;
  .ball {
    width: 30px;
    height: 30px;
    background-color: red;
    border-radius: 50%;
    animation: ${fadeInOut} 1.5s linear infinite;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  .card-container {
    perspective: 1000px;
    width: 210px;
    height: 210px;
    border-radius: 50%;
    &.secondary {
      width: 150px;
      height: 150px;
    }
  }

  .card {
    width: 100%;
    height: 100%;
    transition: transform 0.8s;
    transform-style: preserve-3d;
    position: relative;
  }

  .card-front,
  .card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 50%;
  }

  .card-front {
    background-color: #f0f0f0;
    background-image: url("/chip_blue.png");
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .secondary .card-front {
    background-image: url("/chip_red.png");
  }
  .card-back {
    background-color: #333;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotateY(180deg);
  }

  .card.flipped {
    transform: rotateY(180deg);
  }
`;

export default ResultDeclaration;
